<page-headline [module]="'my-vision'" [moduleIcon]="'fa-star'" [pageTitle]="'My Vision'">
</page-headline>

<app-transition-directory-cards [applicationPage]="'my-vision'"></app-transition-directory-cards>
